import { workStatus as workStatusList } from "@/lib/novelSettings";
import type { Novel, NovelSetting } from "@/lib/models";
import type { NovelGroupSummary } from "@/lib/models/novelGroup";

export type AssistantCatHomeWorkFilters = {
  searchQuery: string;
  workStatuses: NovelSetting[];
  genres: NovelSetting[];
  categories: NovelSetting[];
  groups: NovelGroupSummary[];
};

export function hasAssistantCatHomeWorkFilters(filters: Omit<AssistantCatHomeWorkFilters, "searchQuery">): boolean {
  return (
    filters.workStatuses.length > 0 ||
    filters.genres.length > 0 ||
    filters.categories.length > 0 ||
    filters.groups.length > 0
  );
}

/** Mobile `AssistantCatWorkSelectPage._filterNovels` / Web ホーム NovelList と同じ AND + 軸内 OR */
export function filterAssistantCatHomeNovels(novels: Novel[], filters: AssistantCatHomeWorkFilters): Novel[] {
  const query = filters.searchQuery.trim().toLowerCase();
  const defaultWorkStatusId = workStatusList[0]?.id;

  return novels.filter((novel) => {
    if (query && !(novel.title || "").toLowerCase().includes(query)) {
      return false;
    }
    if (filters.genres.length > 0 && !filters.genres.some((genre) => novel.genre === genre.id)) {
      return false;
    }
    if (filters.categories.length > 0 && !filters.categories.some((category) => novel.category?.includes(category.id))) {
      return false;
    }
    if (filters.workStatuses.length > 0) {
      const matchesWorkStatus = filters.workStatuses.some((status) => {
        if (status.id === defaultWorkStatusId) {
          return !novel.workStatus || novel.workStatus === status.id;
        }
        return novel.workStatus === status.id;
      });
      if (!matchesWorkStatus) {
        return false;
      }
    }
    if (filters.groups.length > 0 && !filters.groups.some((group) => novel.groups?.some((item) => item.groupId === group.groupId))) {
      return false;
    }
    return true;
  });
}
